module.exports = __webpack_public_path__ + "static/media/locationLogo.efd4214c.svg";